export const INTRO_CONSTANTS = {
  title: "Reclaim Flexibility with OpenStack-Powered Infrastructure ",
  text: "Tired of unpredictable cloud expenses and vendor-specific limitations? OneMind MOST delivers a consistent, secure, and cost-efficient alternative — combining open architecture with built-in observability, automation, and platform extensibility. ",
};
